<script>
export default {
  name: 'McpClientGuide',
  props: {
    provider: {
      type: Object,
      required: true,
    },
    mcpUrl: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    copiedStepIndex: null,
  }),
  computed: {
    steps() {
      const interpolate = (value) => (typeof value === 'string'
        ? value.replace(/{{MCP_URL}}/g, this.mcpUrl)
        : value);

      return this.provider.steps.map((step) => ({
        action: interpolate(step.action),
        path: interpolate(step.path),
        copyValue: interpolate(step.copy),
        copyLabel: step.copyLabel,
      }));
    },
  },
  methods: {
    onCopySuccess(index) {
      this.copiedStepIndex = index;
      if (typeof this.$copySuccess === 'function') this.$copySuccess();
      setTimeout(() => {
        if (this.copiedStepIndex === index) this.copiedStepIndex = null;
      }, 2000);
    },
    onCopyError() {
      if (typeof this.$copyError === 'function') this.$copyError();
    },
  },
};
</script>

<template>
  <div>
    <ol class="mcpguide_steps">
      <li v-for="(step, index) in steps" :key="index" class="mcpguide_step">
        <p class="mb-1">
          {{ step.action }}
        </p>
        <p v-if="step.path" class="mcpguide_path is-family-monospace is-size-7 mb-0">
          {{ step.path }}
        </p>

        <div v-if="step.copyValue" class="mcpguide_copy mt-2 is-flex is-align-items-center">
          <code class="is-family-monospace is-size-7 break-words">{{ step.copyValue }}</code>
          <b-button
            type="is-primary"
            size="is-small"
            class="ml-2 mcpguide_copybtn"
            :icon-left="copiedStepIndex === index ? 'check' : 'copy'"
            :aria-label="`Copier ${step.copyLabel} pour ${provider.name}`"
            :title="copiedStepIndex === index ? 'Copié' : `Copier ${step.copyLabel}`"
            v-clipboard:copy="step.copyValue"
            v-clipboard:success="() => onCopySuccess(index)"
            v-clipboard:error="onCopyError"
          />
        </div>
      </li>
    </ol>

    <b-message type="is-info" size="is-small" class="mt-4 mb-0">
      Teachizy n’accorde jamais plus de droits que votre rôle et votre forfait
      {{ provider.name }} ne l’autorisent.
    </b-message>

    <div class="has-text-right mt-3">
      <b-button
        tag="a"
        type="is-text"
        size="is-small"
        :href="provider.docsUrl"
        target="_blank"
        rel="noopener noreferrer"
        icon-right="external-link-alt"
        :aria-label="`Documentation officielle ${provider.name}`"
      >
        Docs officielles {{ provider.name }}
      </b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mcpguide_steps {
  list-style: decimal;
  padding-left: 1.25rem;
  margin-bottom: 1.25rem;
}

.mcpguide_step {
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.mcpguide_path {
  color: #7a7a7a;
}

.mcpguide_copy code {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.35rem 0.5rem;
  background: #f5f5f5;
  border-radius: 4px;
}

.mcpguide_copybtn {
  flex-shrink: 0;
}
</style>
